import { render, staticRenderFns } from "./RecentlyViewedTable.vue?vue&type=template&id=1107f1f5&scoped=true&"
import script from "./RecentlyViewedTable.vue?vue&type=script&lang=ts&"
export * from "./RecentlyViewedTable.vue?vue&type=script&lang=ts&"
import style0 from "./RecentlyViewedTable.vue?vue&type=style&index=0&id=1107f1f5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1107f1f5",
  null
  
)

export default component.exports